import { DetailedUser } from "./DetailedUser";

export class Referral {
    id: string = "";
    referree: DetailedUser | null = null;
    referredBy: DetailedUser | null = null;
    registeredAt: Date | null = null;

    constructor(init?: Partial<Referral>) {
        if (!init) {
            return;
        }

        Object.assign(this, init);

        if (init.referree) {
            this.referree = new DetailedUser(init.referree);
        }

        if (init.referredBy) {
            this.referredBy = new DetailedUser(init.referredBy);
        }

        if (init.registeredAt) {
            this.registeredAt = new Date(init.registeredAt);
        }
    }
}
